import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Colors from '~/styles/colors';

export const container = {
  position: 'absolute',
  top: 32,
  left: '50%',
  transform: 'translate(-50%, 0px)',
  background: '#121212',
  border: '1.2px solid #323232',
  borderRadius: 6,
  padding: { xs: 1.5, sm: 2 },
  width: '87%'
};

export const containerMessageList = {
  width: '100%',
  minHeight: 300,
  maxWidth: 'calc(100hv - 300px)'
};

export const titleStyle = {
  fontWeight: 'bold',
  fontSize: { xs: 18, sm: 20, md: 24 }
};
export const subtitleStyle = {
  fontWeight: 'bold'
};
export const subtitleGreenStyle = {
  fontWeight: 'bold',
  color: Colors.info?.main || '#03DAC5',
  textAlign: 'center',
  marginBottom: 1
};
export const cardContainer = {
  borderRadius: 4
};
export const descriontionStyle = {
  marginY: { xs: 1.25, md: 2 },
  fontSize: { xs: 16, md: 20 }
};
export const containerCards = {
  overflow: 'auto',
  maxHeight: '70vh'
};
export const containerTitle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between'
};
export const containerIcon = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 1,
  margin: 0.5,
  borderRadius: '50%',
  backgroundColor: '#323232'
};
export const containerIcons = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center'
};
export const paragraphStyle = {
  fontSize: { xs: 14, md: 16 },
  marginBottom: 1
};

export const StyledLink = styled(Link)`
  color: ${Colors?.primary?.light};
`;
